import axios from '../lib/axios';
import { MERCHANT_STORE_FIND_MANY } from '../lib/endpoints/merchant';
import { MerChantModel } from '../models/merChantModel';

export const getMerchantData = async (): Promise<MerChantModel[]> => {
  const resData = await axios.get(MERCHANT_STORE_FIND_MANY);
  return resData?.data;
};
